<div class="labels-container">
    @for(label of this.content();track label){
        <span class="label-chip">
            {{label}}
        </span>
    }
</div>